<template>

  <div class="order-logs-page">
     <b-row
      > <b-col
        md="12"
        lg="12"
        sm="12"
        > <KTCodePreview :title="pageTitle"
          > <template v-slot:toolbar
            > <b-button
              variant="secondary"
              size="sm"
              @click="navigateBack"
              > <i class="flaticon2-back"></i> Quay lại </b-button
            > </template
          > <template v-slot:preview
            > <order-log-filter
              :sync-queue-counts="syncQueueCounts"
              :syncing="syncing || syncingByOrderSn"
              :printing-tracking="printingTrackingByOrderSn"
              :printing-tracking-batch="printingTrackingBatch"
              :bulk-creating-shipment="bulkCreatingShipment"
              :exporting-order-logs="exportingOrderLogs"
              :selected-print-count="selectedTrackingOrderSns.length"
              :can-print-batch="selectedTrackingOrderSns.length > 0"
              :selected-change-status-count="selectedChangeStatusOrderCount"
              :can-change-status-batch="selectedChangeStatusOrderCount > 0"
              :selected-bulk-create-shipment-count="eligibleCreateShipmentOrdersForSelection.length"
              :can-bulk-create-shipment="eligibleCreateShipmentOrdersForSelection.length > 0"
              :selected-bulk-confirm-ship-count="eligibleConfirmShipOrdersForSelection.length"
              :can-bulk-confirm-ship-order="eligibleConfirmShipOrdersForSelection.length > 0"
              :resolving-shipment-select-all="resolvingShipmentSelectAll"
              :connections="connections"
              :selected-connection-id="selectedConnectionId"
              :loading-connections="loadingConnections"
              :initial-filters="filters"
              :logistics-options="logisticsOptions"
              :loading-logistics-options="loadingLogisticsOptions"
              @apply-filters="handleApplyFilters"
              @trigger-sync="handleTriggerSync"
              @sync-by-order-sn="handleSyncByOrderSn"
              @print-tracking-by-order-sn="handlePrintTrackingByOrderSn"
              @print-tracking-batch="handlePrintTrackingBatch"
              @bulk-select-ready-to-ship="handleBulkSelectReadyToShip"
              @select-all-shipment-by-filter="handleSelectAllShipmentByFilter"
              @bulk-create-shipment="handleBulkCreateShipmentFlow"
              @bulk-confirm-ship-order="handleBulkConfirmShipOrderFlow"
              @export-order-logs-excel="handleExportOrderLogsExcel"
              @change-internal-order-status-batch="handleChangeInternalOrderStatusBatch"
              @connection-change="handleConnectionChange"
              @logistics-dropdown-open="handleLogisticsDropdownOpen"
            />
            <div
              v-if="selectedConnectionId"
              class="order-logs-page__external-status-tabs-wrap mb-3"
            >

              <div class="order-logs-page__external-status-tabs-toolbar">

                <div
                  class="order-logs-page__external-status-tabs-row"
                  role="tablist"
                >
                   <button
                    v-for="tab in externalStatusTabs"
                    :key="tab.key"
                    type="button"
                    role="tab"
                    class="order-logs-page__external-status-tab"
                    :class="{
                      'order-logs-page__external-status-tab--active':
                        isExternalStatusTabActive(tab),
                    }"
                    :aria-selected="isExternalStatusTabActive(tab) ? 'true' : 'false'"
                    @click="handleExternalStatusTabClick(tab)"
                  >
                     <span class="order-logs-page__external-status-tab-label">{{ tab.label }}</span
                    > <span class="order-logs-page__external-status-tab-count"
                      >({{ tab.count }})</span
                    > </button
                  >
                </div>
                 <span
                  v-if="loadingExternalStatusCounts"
                  class="order-logs-page__external-status-tabs-loading"
                  > Đang cập nhật số liệu… </span
                >
              </div>
               <span
                v-if="externalStatusCountsTruncated"
                class="order-logs-page__external-status-tabs-hint"
                > Kết quả đếm có thể bị giới hạn (truncated). Thu hẹp bộ lọc để chính xác hơn.
                </span
              >
            </div>

            <div
              v-if="!loading && logs.length === 0"
              class="order-logs-page__empty"
            >

              <div class="text-center py-5">
                 <i class="flaticon2-list-3 icon-3x text-muted mb-3"></i>
                <h4 class="text-muted mb-3">Chưa có lịch sử đồng bộ</h4>

                <p class="text-muted mb-4">
                   Nhấn "Đồng bộ" để bắt đầu đồng bộ đơn hàng từ sàn TMĐT
                </p>

              </div>

            </div>
             <order-log-table
              v-if="logs.length > 0 || loading"
              :items="logs"
              :loading="loading"
              :complaint-map="complaintMap"
              :retrying-ids="retryingIds"
              :syncing-status-ids="syncingStatusIds"
              :printing-tracking-ids="printingTrackingIds"
              :sync-queue-jobs-by-order-sn="syncQueueJobsByOrderSn"
              :syncing-one-order-ids="syncingOneOrderIds"
              :creating-shipment-ids="creatingShipmentIds"
              :printing-pdf-ids="printingPdfIds"
              :selected-order-sns="selectedTrackingOrderSns"
              :row-action-errors="rowActionErrors"
              @retry="handleRetry"
              @sync-one-order="handleSyncOneOrder"
              @view-error="handleViewError"
              @print-tracking="handlePrintTracking"
              @print-tracking-pdf="handlePrintTrackingPdf"
              @toggle-select-order="handleToggleSelectOrder"
              @toggle-select-all="handleToggleSelectAll"
              @create-shipment="handleCreateShipment"
              @confirm-ship-order="handleConfirmShipOrder"
              @sync-status-to-shopee="handleSyncStatusToShopee"
              @view-order-detail="handleViewOrderDetail"
              @view-return-detail="handleViewReturnDetail"
              @create-complaint="handleCreateComplaint"
              @change-internal-order-status="handleChangeInternalOrderStatusOne"
              @dismiss-row-error="clearRowActionError"
            /> <order-log-pagination
              v-if="logs.length > 0"
              :current-page="pagination.page"
              :total-items="pagination.total"
              :per-page="pagination.limit"
              @page-change="handlePageChange"
            /> <error-modal ref="errorModal" /> <return-detail-modal ref="returnDetailModalRef" />
            <create-complaint-modal
              ref="createComplaintModalRef"
              @created="handleComplaintCreated"
            /> <b-modal
              size="xl"
              hide-footer
              :title="titleOrderFromModal"
              id="md-edit-order"
              > <UsertOrder
                :fromModal="true"
                :orderIdFromModal="orderIdFromModal"
                @refresh-order="refreshOrder"
              /> </b-modal
            > </template
          > </KTCodePreview
        > <template v-if="checkPermissions(['ORDER_UPDATE']) && userInfor"
          > <order-change-common
            mode="changeStatus"
            :user-infor="userInfor"
            @refresh="onInternalOrderStatusChanged"
          /> </template
        > </b-col
      > </b-row
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import OrderLogFilter from './components/OrderLogFilter.vue'
  import OrderLogTable from './components/OrderLogTable.vue'
  import OrderLogPagination from './components/OrderLogPagination.vue'
  import ErrorModal from './shared/ErrorModal.vue'
  import ReturnDetailModal from './components/ReturnDetailModal.vue'
  import CreateComplaintModal from './components/CreateComplaintModal.vue'
  import OrderChangeCommon from '@/view/components/order/OrderChangeCommon.vue'
  import UsertOrder from '@/view/pages/order/UpsertOrder.vue'
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  import { getToastInstance } from '@/utils/toastHelper'
  import { EventBus } from '@/core/services/event-bus'
  import { SET_ORDER_STATUS_SELECTED } from '@/core/services/store/modules/order/order-seleted-status.module.js'
  import { checkPermissions } from '@/utils/saveDataToLocal'
  import { getEmployeeFromLocal } from '@/utils/common'
  import Swal from 'sweetalert2'
  import moment from 'moment'
  import { getStartOfDay, getEndOfDay } from '@/utils/date'
  import {
    processPrintTrackingApiResponse,
    mergeAndOpenPdfBase64List,
  } from '@/utils/shopeePrintTracking'
  import { buildCreateShipmentExtras, SHIP_UI_MODE_PRESET } from '@/utils/shopeeManualShipment'
  import {
    derivePresetShipChoices,
    getShipmentConfirmSwalHtml,
    attachShipmentConfirmDialogListeners,
    parseShipmentConfirmPreConfirm,
    resolveShopeePackageNumberForShipApi,
    finalizeShipChoices,
    orderRequiresPickupNotDropoff,
    getDropoffShipmentPayloadFromOrderPackageList,
  } from '@/utils/shopeeShippingConfirmDialog'
  import { buildShopeeConfirmOrderPayload } from '@/utils/shopeeConfirmOrderFlags'
  import fileDownload from '@/utils/file-download'
  import { EXTERNAL_STATUS_OPTIONS, EXTERNAL_STATUS_BADGE_MAP } from './constants'
  const shopeeAdminRepo = RepositoryFactory.get('shopeeAdmin')
  const platformRepo = RepositoryFactory.get('platformIntegration')
  const toast = getToastInstance()

  export default {
    name: 'OrderLogs',
    components: {
      KTCodePreview,
      OrderLogFilter,
      OrderLogTable,
      OrderLogPagination,
      ErrorModal,
      ReturnDetailModal,
      CreateComplaintModal,
      OrderChangeCommon,
      UsertOrder,
    },
    data() {
      return {
        logs: [],
        loading: true,
        syncing: false,
        retryingIds: [],
        syncingStatusIds: [],
        printingTrackingIds: [],
        syncingOneOrderIds: [],
        creatingShipmentIds: [],
        printingPdfIds: [],
        syncingByOrderSn: false,
        printingTrackingByOrderSn: false,
        printingTrackingBatch: false,
        bulkCreatingShipment: false,
        exportingOrderLogs: false,
        selectedTrackingOrderSns: [],
        filters: {},
        pagination: {
          page: 1,
          limit: 20,
          total: 0,
          totalPages: 0,
        },
        connections: [],
        selectedConnectionId: null,
        loadingConnections: false,
        complaintMap: {},
        orderIdFromModal: null,
        titleOrderFromModal: 'Chỉnh sửa đơn hàng',
        rowActionErrors: {},
        rowActionErrorTimers: {},
        syncQueueJobsByOrderSn: {},
        syncQueueCounts: null,
        syncQueuePollTimer: null,
        userInfor: null,
        externalStatusCountRows: [],
        externalStatusCountTotal: 0,
        externalStatusCountsTruncated: false,
        loadingExternalStatusCounts: false,
        resolvingShipmentSelectAll: false,
        logisticsOptions: [],
        loadingLogisticsOptions: false,
      }
    },
    computed: {
      externalStatusTabs() {
        const total = Number(this.externalStatusCountTotal) || 0
        const tabs = [
          {
            key: '__all__',
            externalStatus: null,
            label: 'Tất cả',
            count: total,
          },
        ]
        const rows = Array.isArray(this.externalStatusCountRows)
          ? [...this.externalStatusCountRows]
          : []
        const orderIdx = {}
        EXTERNAL_STATUS_OPTIONS.filter((o) => o.value).forEach((o, i) => {
          orderIdx[o.value] = i
        })
        rows.sort((a, b) => {
          const sa = String(a.externalStatus || '')
          const sb = String(b.externalStatus || '')
          const ia = orderIdx[sa]
          const ib = orderIdx[sb]
          if (ia !== undefined && ib !== undefined) return ia - ib
          if (ia !== undefined) return -1
          if (ib !== undefined) return 1
          return sa.localeCompare(sb)
        })
        rows.forEach((r) => {
          const code = r.externalStatus
          tabs.push({
            key: String(code),
            externalStatus: code,
            label: this.externalStatusTabLabel(code),
            count: Number(r.count) || 0,
          })
        })
        return tabs
      },
      pageTitle() {
        return 'Quản lý đơn hàng'
      },
      selectedChangeStatusOrderCount() {
        return this.logs.filter(
          (order) =>
            this.selectedTrackingOrderSns.includes(order.externalOrderId) &&
            this.canChangeInternalOrderStatusForLog(order),
        ).length
      },
      /**
       * Đơn đủ điều kiện bulk create-shipment trong lựa chọn (READY_TO_SHIP, RETRY_SHIP, PROCESSED).
       */
      eligibleCreateShipmentOrdersForSelection() {
        if (!this.selectedConnectionId) return []
        const bySn = new Map(
          this.logs.filter((o) => o?.externalOrderId).map((o) => [o.externalOrderId, o]),
        )
        const seen = new Set()
        const out = []
        for (const sn of this.selectedTrackingOrderSns) {
          if (!sn || seen.has(sn)) continue
          seen.add(sn)
          const row = bySn.get(sn)
          if (row && this.orderEligibleForCreateShipment(row)) out.push(row)
          else if (!row) {
            out.push({
              externalOrderId: sn,
              marketplaceConnectionId: Number(this.selectedConnectionId),
              syncStatus: 'synced',
              externalStatus: 'READY_TO_SHIP',
              rawOrderData: {},
            })
          }
        }
        return out
      },
      /**
       * Đơn đủ điều kiện bulk confirm-ship-order (chỉ READY_TO_SHIP, RETRY_SHIP).
       */
      eligibleConfirmShipOrdersForSelection() {
        if (!this.selectedConnectionId) return []
        const bySn = new Map(
          this.logs.filter((o) => o?.externalOrderId).map((o) => [o.externalOrderId, o]),
        )
        const seen = new Set()
        const out = []
        for (const sn of this.selectedTrackingOrderSns) {
          if (!sn || seen.has(sn)) continue
          seen.add(sn)
          const row = bySn.get(sn)
          if (row && this.orderEligibleForConfirmShipOrder(row)) out.push(row)
          else if (!row) {
            out.push({
              externalOrderId: sn,
              marketplaceConnectionId: Number(this.selectedConnectionId),
              syncStatus: 'synced',
              externalStatus: 'READY_TO_SHIP',
              rawOrderData: {},
            })
          }
        }
        return out
      },
    },
    watch: {
      '$route.query': {
        handler(newQuery) {
          const prevConnectionId = this.selectedConnectionId
          this.restoreFromQuery(newQuery)
          if (String(this.selectedConnectionId ?? '') !== String(prevConnectionId ?? '')) {
            this.fetchLogisticsOptions({ reason: 'route-query-connection-change' })
          }
          this.fetchLogs()
        },
      },
    },
    async mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Kênh bán', route: '/platform-integration' },
        { title: 'Quản lý đơn hàng' },
      ])
      this.userInfor = getEmployeeFromLocal()
      await this.fetchConnections()
      this.restoreFromQuery(this.$route.query)
      await this.fetchLogisticsOptions({ reason: 'mounted' })
      this.fetchLogs()
    },
    beforeDestroy() {
      this.clearSyncQueuePoll()
      Object.keys(this.rowActionErrorTimers).forEach((sn) => {
        clearTimeout(this.rowActionErrorTimers[sn])
      })
      this.rowActionErrorTimers = {}
    },
    methods: {
      extractApiFailureMessage(response, fallback = 'Thao tác thất bại') {
        if (!response || response.success !== false) return fallback
        const d = response.data
        const candidates = [response.error, response.message, d?.error, d?.message]
        for (const c of candidates) {
          if (typeof c === 'string' && c.trim()) return c.trim()
        }
        return fallback
      },
      extractAxiosErrorMessage(error, fallback = 'Thao tác thất bại') {
        const data = error?.response?.data
        if (data) {
          const nested = data.data
          const candidates = [data.error, data.message, nested?.error, nested?.message]
          for (const c of candidates) {
            if (typeof c === 'string' && c.trim()) return c.trim()
          }
        }
        if (error?.message && typeof error.message === 'string' && error.message.trim()) {
          return error.message.trim()
        }
        return fallback
      },
      extractBatchPrintItemError(item, fallback = 'Không thể in mã vận đơn') {
        const candidates = [item?.error, item?.message, item?.data?.error, item?.data?.message]
        for (const c of candidates) {
          if (typeof c === 'string' && c.trim()) return c.trim()
        }
        return fallback
      },
      applyBatchPrintRowErrors(failedItems = []) {
        const errorByOrderSn = new Map()
        failedItems.forEach((item) => {
          const orderSn = item?.orderSn
          if (!orderSn) return
          const message = this.extractBatchPrintItemError(item)
          const prev = errorByOrderSn.get(orderSn)
          if (!prev || message.length > prev.length) {
            errorByOrderSn.set(orderSn, message)
          }
        })
        errorByOrderSn.forEach((message, orderSn) => {
          this.setRowActionError(orderSn, message, { persist: true })
        })
      },
      setRowActionError(orderSn, message, { persist = false } = {}) {
        if (!orderSn || !message) return
        const prevTimer = this.rowActionErrorTimers[orderSn]
        if (prevTimer != null) {
          clearTimeout(prevTimer)
          this.$delete(this.rowActionErrorTimers, orderSn)
        }
        this.$set(this.rowActionErrors, orderSn, message)
        if (persist) return
        const timerId = window.setTimeout(() => {
          this.clearRowActionError(orderSn)
        }, 2000)
        this.$set(this.rowActionErrorTimers, orderSn, timerId)
      },
      clearRowActionError(orderSn) {
        const t = this.rowActionErrorTimers[orderSn]
        if (t != null) {
          clearTimeout(t)
          this.$delete(this.rowActionErrorTimers, orderSn)
        }
        if (!orderSn || !Object.prototype.hasOwnProperty.call(this.rowActionErrors, orderSn)) {
          return
        }
        this.$delete(this.rowActionErrors, orderSn)
      },
      buildPrintTrackingParams(order = {}, overrides = {}) {
        const { confirmOrderBeforeShip, forceConfirmOrder, ...rest } = overrides
        return {
          orderSn: rest.orderSn ?? order.externalOrderId,
          connectionId:
            rest.connectionId ?? order.marketplaceConnectionId ?? this.selectedConnectionId,
          orderId: rest.orderId ?? order.orderId,
          packageNumber:
            rest.packageNumber ?? resolveShopeePackageNumberForShipApi(order),
          ...buildShopeeConfirmOrderPayload({
            confirmOrderBeforeShip,
            forceConfirmOrder,
          }),
        }
      },
      async openTrackingByApi(params, preferPdf = true) {
        const hasManualShipPayload =
          params &&
          params.shipType &&
          (params.shipType === 'pickup'
            ? params.pickup && typeof params.pickup === 'object'
            : params.shipType === 'dropoff'
              ? params.dropoff && typeof params.dropoff === 'object'
              : false)

        if (preferPdf) {
          try {
            const apiRes = hasManualShipPayload
              ? await shopeeAdminRepo.fetchPrintTrackingPdfPost(params)
              : await shopeeAdminRepo.fetchPrintTrackingPdf(params)
            return processPrintTrackingApiResponse(apiRes)
          } catch (pdfError) {
            const apiRes = hasManualShipPayload
              ? await shopeeAdminRepo.fetchPrintTrackingPost(params)
              : await shopeeAdminRepo.fetchPrintTracking(params)
            return processPrintTrackingApiResponse(apiRes)
          }
        }
        const apiRes = hasManualShipPayload
          ? await shopeeAdminRepo.fetchPrintTrackingPost(params)
          : await shopeeAdminRepo.fetchPrintTracking(params)
        return processPrintTrackingApiResponse(apiRes)
      },
      async fetchConnections() {
        try {
          this.loadingConnections = true
          const platform = this.$route.query.platform || 'shopee'
          const response = await platformRepo.getConfigs({ platform })
          this.connections = (response.items || []).filter((c) => c.status === 'connected')
          const queryConnectionId = this.$route.query.connectionId
          if (queryConnectionId != null && queryConnectionId !== '') {
            const conn = this.connections.find(
              (c) => String(c.id) === String(queryConnectionId),
            )
            if (conn) {
              this.selectedConnectionId = conn.id
            }
          } else if (this.connections.length === 1) {
            this.selectedConnectionId = this.connections[0].id
          }
        } catch (error) {
          console.error('Error fetching connections:', error)
          toast.makeToastFailure('Không thể tải danh sách kết nối')
        } finally {
          this.loadingConnections = false
        }
      },
      /**
       * Query giống GET orders/logs — dùng cho danh sách (có page/limit) và xuất Excel (không phân trang UI).
       */
      buildOrderLogsQueryParams({ includePagination = false } = {}) {
        const params = includePagination
          ? {
              page: this.pagination.page,
              limit: this.pagination.limit,
              ...this.filters,
            }
          : { ...this.filters }

        if (params.externalOrderId) {
          delete params.search
        }

        if (this.selectedConnectionId) {
          params.connectionId = this.selectedConnectionId
        }

        if (params.fromDate) {
          params.fromDate = getStartOfDay(params.fromDate)
        }
        if (params.toDate) {
          params.toDate = getEndOfDay(params.toDate)
        }

        if (params.hasReturnSnList == null) {
          delete params.hasReturnSnList
        }

        const imeiTrimmed = typeof params.imeiCode === 'string' ? params.imeiCode.trim() : ''
        if (imeiTrimmed) {
          params.imeiCode = imeiTrimmed
        } else {
          delete params.imeiCode
        }

        const productNameTrimmed =
          typeof params.productName === 'string' ? params.productName.trim() : ''
        if (productNameTrimmed) {
          params.productName = productNameTrimmed
        } else {
          delete params.productName
        }

        const logisticsTrimmed = typeof params.logistics === 'string' ? params.logistics.trim() : ''
        if (logisticsTrimmed) {
          params.logistics = logisticsTrimmed
          delete params.logisticsChannelId
        } else {
          delete params.logistics
        }

        const channelIdRaw = params.logisticsChannelId
        if (channelIdRaw != null && String(channelIdRaw).trim() !== '') {
          params.logisticsChannelId = String(channelIdRaw).trim()
          delete params.logistics
        } else {
          delete params.logisticsChannelId
        }

        if (!includePagination) {
          delete params.page
          delete params.limit
        }

        return params
      },
      /** Body/query cho POST reports/resolve-platform-order-ids — cùng filter GET orders/logs. */
      buildResolveShipmentSelectionPayload() {
        const params = this.buildOrderLogsQueryParams({ includePagination: false })
        params.cap = 10000
        return params
      },
      buildOrderLogsCountParams() {
        const params = { ...this.buildOrderLogsQueryParams({ includePagination: false }) }
        delete params.externalStatus
        return params
      },
      externalStatusTabLabel(code) {
        if (code == null || code === '') return ''
        const fromOpts = EXTERNAL_STATUS_OPTIONS.find((o) => o.value === code)
        if (fromOpts) return fromOpts.text
        const fromBadge = EXTERNAL_STATUS_BADGE_MAP[code]
        if (fromBadge?.text) return fromBadge.text
        return String(code)
      },
      isExternalStatusTabActive(tab) {
        if (tab.externalStatus == null) {
          return (
            this.filters.externalStatus == null ||
            this.filters.externalStatus === '' ||
            this.filters.externalStatus === undefined
          )
        }
        return this.filters.externalStatus === tab.externalStatus
      },
      async fetchExternalStatusCounts() {
        if (!this.selectedConnectionId) {
          this.externalStatusCountRows = []
          this.externalStatusCountTotal = 0
          this.externalStatusCountsTruncated = false
          return
        }
        const params = this.buildOrderLogsCountParams()

        this.loadingExternalStatusCounts = true
        try {
          const envelope = await shopeeAdminRepo.getOrderLogsCountByStatus(params)
          const payload =
            envelope?.data !== undefined && typeof envelope.data === 'object'
              ? envelope.data
              : envelope || {}
          this.externalStatusCountTotal = Number(payload.total) || 0
          this.externalStatusCountsTruncated = !!payload.truncated
          this.externalStatusCountRows = Array.isArray(payload.byExternalStatus)
            ? payload.byExternalStatus
            : []
        } catch (e) {
          console.error('Error fetching order logs count-by-status:', e)
          this.externalStatusCountRows = []
          this.externalStatusCountTotal = 0
          this.externalStatusCountsTruncated = false
        } finally {
          this.loadingExternalStatusCounts = false
        }
      },
      handleExternalStatusTabClick(tab) {
        if (!tab || !this.selectedConnectionId) return
        const normalize = (v) => {
          if (v == null || v === '') return null
          return v
        }
        const next = normalize(tab.externalStatus != null ? tab.externalStatus : null)
        const cur = normalize(this.filters.externalStatus)
        if (cur === next) return
        this.filters = {
          ...this.filters,
          externalStatus: next,
        }
        this.pagination.page = 1
        this.selectedTrackingOrderSns = []
        this.updateQueryParams()
      },
      async fetchLogs() {
        this.fetchExternalStatusCounts()
        try {
          this.loading = true
          const params = this.buildOrderLogsQueryParams({ includePagination: true })

          const response = await shopeeAdminRepo.getOrderLogs(params)
          this.logs = response.data || []
          this.syncSelectedTrackingOrderSnsWithCurrentLogs()
          if (response.pagination) {
            this.pagination = {
              page: response.pagination.page,
              limit: response.pagination.pageSize,
              total: response.pagination.total,
              totalPages: response.pagination.totalPages,
            }
          }
          await this.fetchComplaintMap()
          await this.fetchSyncQueueSnapshot()
          this.adjustSyncQueuePolling()
        } catch (error) {
          console.error('Error fetching order logs:', error)
          toast.makeToastFailure('Không thể tải lịch sử đơn hàng')
        } finally {
          this.loading = false
        }
      },
      async handleExportOrderLogsExcel() {
        if (!this.selectedConnectionId) {
          toast.makeToastFailure('Vui lòng chọn gian hàng trước khi xuất Excel')
          return
        }
        this.exportingOrderLogs = true
        try {
          const params = this.buildOrderLogsQueryParams({ includePagination: false })
          const response = await shopeeAdminRepo.exportOrderLogs(params)
          const ctype = String(response.headers['content-type'] || '').toLowerCase()
          if (ctype.includes('application/json')) {
            const text = await response.data.text()
            let msg = 'Xuất Excel thất bại'
            try {
              const j = JSON.parse(text)
              msg =
                [j.message, j.error, j.msg].find((x) => typeof x === 'string' && x.trim()) || msg
            } catch (_) {
              /* ignore */
            }
            toast.makeToastFailure(msg)
            return
          }
          let fileName = `DonSanShopee-${moment().format('YYYY-MM-DD_HHmmss')}.xlsx`
          try {
            fileName = fileDownload.getFileName(response)
          } catch (_) {
            /* dùng tên mặc định */
          }
          fileDownload.createFile(response.data, fileName)
          toast.makeToastSuccess('Đã tải file Excel')
        } catch (error) {
          console.error('Error exporting Shopee order logs:', error)
          let msg = this.extractAxiosErrorMessage(error, 'Không thể xuất Excel')
          const blobData = error?.response?.data
          if (blobData instanceof Blob) {
            try {
              const text = await blobData.text()
              const j = JSON.parse(text)
              msg = [j.message, j.error].find((x) => typeof x === 'string' && x.trim()) || msg
            } catch (_) {
              /* ignore */
            }
          }
          toast.makeToastFailure(msg)
        } finally {
          this.exportingOrderLogs = false
        }
      },
      clearSyncQueuePoll() {
        if (this.syncQueuePollTimer != null) {
          clearInterval(this.syncQueuePollTimer)
          this.syncQueuePollTimer = null
        }
      },
      getSyncQueuePendingTotal() {
        const c = this.syncQueueCounts
        if (!c || typeof c !== 'object') return 0
        return (Number(c.waiting) || 0) + (Number(c.active) || 0) + (Number(c.delayed) || 0)
      },
      shouldPollSyncQueue() {
        if (!this.selectedConnectionId) return false
        if (this.syncing || this.syncingByOrderSn) return true
        if (Array.isArray(this.syncingOneOrderIds) && this.syncingOneOrderIds.length > 0) {
          return true
        }
        return this.getSyncQueuePendingTotal() > 0
      },
      adjustSyncQueuePolling() {
        this.clearSyncQueuePoll()
        if (!this.shouldPollSyncQueue()) return
        const tick = async () => {
          await this.fetchSyncQueueSnapshot()
          if (!this.shouldPollSyncQueue()) this.clearSyncQueuePoll()
        }
        this.syncQueuePollTimer = window.setInterval(tick, 3000)
      },
      async fetchSyncQueueSnapshot() {
        if (!this.selectedConnectionId) {
          this.syncQueueJobsByOrderSn = {}
          this.syncQueueCounts = null
          this.clearSyncQueuePoll()
          return
        }
        try {
          const envelope = await shopeeAdminRepo.getSyncQueue({
            connectionId: this.selectedConnectionId,
            types: ['waiting', 'active', 'delayed'],
          })
          const payload =
            envelope && envelope.data !== undefined && typeof envelope.data === 'object'
              ? envelope.data
              : envelope || {}
          const jobs = Array.isArray(payload.jobs) ? payload.jobs : []
          const map = {}
          const connId = Number(this.selectedConnectionId)
          for (const job of jobs) {
            const sn = job?.data?.orderSn
            if (!sn) continue
            const jobConn = job?.data?.connectionId
            if (jobConn != null && Number(jobConn) !== connId) continue
            map[String(sn)] = {
              state: job.state,
              jobId: job.id,
              attemptsMade: job.attemptsMade,
            }
          }
          this.syncQueueJobsByOrderSn = map
          this.syncQueueCounts =
            payload.counts && typeof payload.counts === 'object' ? payload.counts : null
        } catch (e) {
          console.error('Error fetching Shopee sync queue:', e)
        }
      },
      loadQueryParams() {
        this.restoreFromQuery(this.$route.query)
        this.fetchLogs()
      },
      restoreFromQuery(query) {
        const parseBooleanFilter = (v) => {
          if (v === undefined || v === '' || v === null) return null
          if (v === true || v === 'true' || v === '1' || v === 1 || v === 'yes') return true
          if (v === false || v === 'false' || v === '0' || v === 0 || v === 'no') return false
          return null
        }
        if (query.connectionId !== undefined) {
          const conn = this.connections.find((c) => String(c.id) === String(query.connectionId))
          this.selectedConnectionId = conn ? conn.id : null
          console.log(
            '[ORDER_LOG_LOGISTICS_DEBUG] restoreFromQuery.connectionId',
            JSON.stringify({
              queryConnectionId: query.connectionId,
              resolvedConnectionId: this.selectedConnectionId,
              found: !!conn,
            }),
          )
        }
        const parseOrderStatus = (v) => {
          if (v === undefined || v === '' || v === null) return null
          const n = parseInt(v, 10)
          return isNaN(n) ? null : n
        }
        this.filters = {
          search: query.search !== undefined ? query.search : '',
          externalOrderId: query.externalOrderId !== undefined ? query.externalOrderId : '',
          status: query.status !== undefined ? query.status : null,
          orderStatus: parseOrderStatus(query.orderStatus),
          externalStatus:
            query.externalStatus !== undefined
              ? query.externalStatus === ''
                ? null
                : query.externalStatus
              : null,
          isExpress: parseBooleanFilter(query.isExpress),
          hasReturnSnList: parseBooleanFilter(query.hasReturnSnList),
          trackingNumber: query.trackingNumber !== undefined ? query.trackingNumber : '',
          imeiCode: query.imeiCode !== undefined ? query.imeiCode : '',
          productName: query.productName !== undefined ? query.productName : '',
          logistics: query.logistics !== undefined ? query.logistics : '',
          logisticsChannelId:
            query.logisticsChannelId !== undefined && query.logisticsChannelId !== ''
              ? query.logisticsChannelId
              : null,
          fromDate:
            query.fromDate && moment(query.fromDate, 'YYYY-MM-DD').isValid()
              ? moment(query.fromDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : null,
          toDate:
            query.toDate && moment(query.toDate, 'YYYY-MM-DD').isValid()
              ? moment(query.toDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : null,
        }
        if (query.page) {
          const page = parseInt(query.page, 10)
          this.pagination.page = isNaN(page) ? 1 : page
        } else {
          this.pagination.page = 1
        }
      },
      updateQueryParams() {
        const query = {}
        const platform = this.$route.query.platform || 'shopee'
        query.platform = platform
        if (this.selectedConnectionId) {
          query.connectionId = this.selectedConnectionId
        }
        if (this.filters.externalOrderId?.trim()) {
          query.externalOrderId = this.filters.externalOrderId.trim()
        } else if (this.filters.search?.trim()) {
          query.search = this.filters.search.trim()
        }
        if (this.filters.status) {
          query.status = this.filters.status
        }
        if (this.filters.orderStatus != null && this.filters.orderStatus !== '') {
          query.orderStatus = this.filters.orderStatus
        }
        if (this.filters.externalStatus) {
          query.externalStatus = this.filters.externalStatus
        }
        if (this.filters.isExpress !== null) {
          query.isExpress = this.filters.isExpress ? '1' : '0'
        }
        if (this.filters.hasReturnSnList !== null) {
          query.hasReturnSnList = this.filters.hasReturnSnList ? '1' : '0'
        }
        if (this.filters.trackingNumber?.trim()) {
          query.trackingNumber = this.filters.trackingNumber.trim()
        }
        if (this.filters.imeiCode?.trim()) {
          query.imeiCode = this.filters.imeiCode.trim()
        }
        if (this.filters.productName?.trim()) {
          query.productName = this.filters.productName.trim()
        }
        if (this.filters.logisticsChannelId != null && String(this.filters.logisticsChannelId).trim() !== '') {
          query.logisticsChannelId = String(this.filters.logisticsChannelId).trim()
        } else if (this.filters.logistics?.trim()) {
          query.logistics = this.filters.logistics.trim()
        }
        if (this.filters.fromDate) {
          const d = moment(this.filters.fromDate, 'DD/MM/YYYY')
          if (d.isValid()) query.fromDate = d.format('YYYY-MM-DD')
        }
        if (this.filters.toDate) {
          const d = moment(this.filters.toDate, 'DD/MM/YYYY')
          if (d.isValid()) query.toDate = d.format('YYYY-MM-DD')
        }
        if (this.pagination.page > 1) {
          query.page = this.pagination.page
        }
        this.$router
          .push({
            name: 'platform-integration-orders',
            query,
          })
          .catch((err) => {
            if (err && err.name === 'NavigationDuplicated') {
              this.fetchLogs()
            }
          })
      },
      handleApplyFilters(filters) {
        this.filters = filters
        this.pagination.page = 1
        this.selectedTrackingOrderSns = []
        this.updateQueryParams()
      },
      handleConnectionChange(connectionId) {
        const nextId =
          connectionId === '' || connectionId === 'null' || connectionId === undefined
            ? null
            : connectionId
        console.log(
          '[ORDER_LOG_LOGISTICS_DEBUG] handleConnectionChange',
          JSON.stringify({ connectionId, nextId }),
        )
        this.selectedConnectionId = nextId
        this.pagination.page = 1
        this.selectedTrackingOrderSns = []
        this.logisticsOptions = []
        this.filters = {
          ...this.filters,
          logisticsChannelId: null,
          logistics: '',
        }
        this.fetchLogisticsOptions({ reason: 'connection-change' })
        this.updateQueryParams()
      },
      handleLogisticsDropdownOpen() {
        console.log(
          '[ORDER_LOG_LOGISTICS_DEBUG] logistics-dropdown-open',
          JSON.stringify({
            selectedConnectionId: this.selectedConnectionId,
            logisticsOptionsCount: (this.logisticsOptions || []).length,
            loadingLogisticsOptions: this.loadingLogisticsOptions,
          }),
        )
        this.fetchLogisticsOptions({ reason: 'logistics-dropdown-open' })
      },
      resolveLogisticsConnectionId() {
        const raw = this.selectedConnectionId
        if (raw == null || raw === '') {
          return null
        }
        const n = Number(raw)
        return Number.isFinite(n) && n > 0 ? n : null
      },
      async fetchLogisticsOptions({ reason = 'unknown' } = {}) {
        const connectionId = this.resolveLogisticsConnectionId()
        console.log(
          '[ORDER_LOG_LOGISTICS_DEBUG] 1.fetchLogisticsOptions.entry',
          JSON.stringify({
            reason,
            selectedConnectionId: this.selectedConnectionId,
            resolvedConnectionId: connectionId,
            routeConnectionId: this.$route.query.connectionId,
            connectionsCount: (this.connections || []).length,
          }),
        )
        if (!connectionId) {
          console.log(
            '[ORDER_LOG_LOGISTICS_DEBUG] 2.skip-no-connectionId',
            JSON.stringify({ reason }),
          )
          this.logisticsOptions = []
          return
        }
        this.loadingLogisticsOptions = true
        try {
          console.log(
            '[ORDER_LOG_LOGISTICS_DEBUG] 3.call-api',
            JSON.stringify({
              reason,
              connectionId,
              url: 'v1/admin/shopee/orders/logs/logistics-options',
            }),
          )
          const envelope = await shopeeAdminRepo.getOrderLogisticsOptions({
            connectionId,
          })
          const rows = Array.isArray(envelope?.data) ? envelope.data : []
          console.log(
            '[ORDER_LOG_LOGISTICS_DEBUG] 4.api-success',
            JSON.stringify({ reason, connectionId, count: rows.length }),
          )
          this.logisticsOptions = rows
        } catch (error) {
          console.error('[ORDER_LOG_LOGISTICS_DEBUG] 5.api-error', reason, error)
          this.logisticsOptions = []
          toast.makeToastFailure('Không tải được danh sách ĐVVC / kênh VC từ Shopee')
        } finally {
          this.loadingLogisticsOptions = false
        }
      },
      handlePageChange(page) {
        this.pagination.page = page
        this.selectedTrackingOrderSns = []
        this.updateQueryParams()
      },
      canSelectForBatchPrint(order) {
        return !!order?.externalOrderId
      },
      orderEligibleForCreateShipment(order) {
        const st = order?.externalStatus
        return (
          order?.syncStatus === 'synced' &&
          !!order?.externalOrderId &&
          !!order?.marketplaceConnectionId &&
          (st === 'READY_TO_SHIP' || st === 'RETRY_SHIP' || st === 'PROCESSED')
        )
      },
      orderEligibleForConfirmShipOrder(order) {
        const st = order?.externalStatus
        return (
          order?.syncStatus === 'synced' &&
          !!order?.externalOrderId &&
          !!order?.marketplaceConnectionId &&
          (st === 'READY_TO_SHIP' || st === 'RETRY_SHIP')
        )
      },
      throwIfCreateShipmentFailed(res) {
        if (res?.success === false) {
          throw new Error(res?.error || res?.message || 'Tạo vận đơn thất bại')
        }
        const inner = res?.data ?? {}
        if (inner?.success === false) {
          throw new Error(inner?.error || inner?.message || 'Tạo vận đơn thất bại')
        }
        return inner
      },
      toastCreateShipmentOutcome(inner) {
        if (inner?.alreadyShipped) {
          toast.makeToastSuccess(
            inner?.trackingNumber
              ? `Đơn đã giao trên Shopee. Mã: ${inner.trackingNumber}`
              : 'Đơn đã được giao trên Shopee',
          )
        } else if (inner?.trackingNumber) {
          toast.makeToastSuccess(`Đã lấy mã vận đơn: ${inner.trackingNumber}`)
        } else {
          toast.makeToastSuccess(
            'Đã tạo vận đơn. Nếu chưa thấy mã, hãy Sync đơn hoặc thử In mã vận đơn.',
          )
        }
      },
      async resolveAutoShipmentExtras(order, confirmOpts = {}) {
        const pkgId = resolveShopeePackageNumberForShipApi(order)
        const shipParamQuery = {
          orderSn: order.externalOrderId,
          connectionId: order.marketplaceConnectionId,
          ...(pkgId ? { packageNumber: pkgId } : {}),
          ...buildShopeeConfirmOrderPayload(confirmOpts),
        }
        let res
        try {
          res = await shopeeAdminRepo.fetchShippingParameter(shipParamQuery)
        } catch (e) {
          const fb = getDropoffShipmentPayloadFromOrderPackageList(order)
          if (fb) {
            return { extras: fb, ambiguous: false }
          }
          throw e
        }
        if (res?.success === false) {
          const fb = getDropoffShipmentPayloadFromOrderPackageList(order)
          if (fb) {
            return { extras: fb, ambiguous: false }
          }
          throw new Error(res?.error || res?.message || 'Không lấy được tham số ship từ Shopee')
        }
        let choices = finalizeShipChoices(order, derivePresetShipChoices(res?.data))
        if (!choices.length) {
          const fb = getDropoffShipmentPayloadFromOrderPackageList(order)
          return { extras: fb || {}, ambiguous: false }
        }
        const pickupChoice = choices.find((c) => c.shipType === 'pickup' && c.pickup)
        const c = pickupChoice ?? choices[0]
        const ambiguous = choices.length > 1
        if (c.shipType === 'pickup' && c.pickup) {
          return {
            extras: buildCreateShipmentExtras({
              mode: SHIP_UI_MODE_PRESET,
              shipType: 'pickup',
              pickup: c.pickup,
            }),
            ambiguous,
          }
        }
        if (c.shipType === 'dropoff' && c.dropoff) {
          return {
            extras: buildCreateShipmentExtras({
              mode: SHIP_UI_MODE_PRESET,
              shipType: 'dropoff',
              dropoff: c.dropoff,
            }),
            ambiguous,
          }
        }
        return { extras: {}, ambiguous: false }
      },
      async handleBulkSelectReadyToShip() {
        if (!this.selectedConnectionId) {
          toast.makeToastFailure('Vui lòng chọn gian hàng trước')
          return
        }
        this.pagination.page = 1
        this.filters = {
          ...this.filters,
          externalStatus: 'READY_TO_SHIP',
          status: 'synced',
        }
        this.selectedTrackingOrderSns = []
        this.updateQueryParams()
        await this.fetchLogs()

        const eligible = this.logs.filter((o) => this.orderEligibleForConfirmShipOrder(o))
        if (!eligible.length) {
          toast.makeToastFailure(
            'Không có đơn READY_TO_SHIP đã đồng bộ trên trang hiện tại để chọn.',
          )
          return
        }

        this.selectedTrackingOrderSns = eligible.map((o) => o.externalOrderId)

        let msg = `Đã tick chọn ${eligible.length} đơn (READY_TO_SHIP, đã đồng bộ).`
        if (this.pagination.total > eligible.length) {
          msg += ` Trang hiện tại ${eligible.length}/${this.pagination.total} đơn khớp lọc — mở menu «Đã chọn» → «Tạo shipment» hoặc «Xác nhận ship_order» để chạy API.`
        } else {
          msg += ` Mở menu «Đã chọn» → «Tạo shipment» hoặc «Xác nhận ship_order» để xác nhận lên Shopee.`
        }
        toast.makeToastSuccess(msg)
      },
      async handleSelectAllShipmentByFilter() {
        if (!this.selectedConnectionId) {
          toast.makeToastFailure('Chọn một gian hàng (connection) trước khi resolve danh sách.')
          return
        }
        const sw = await Swal.fire({
          title: 'Chọn đơn theo filter (mọi trang)?',
          html:
            '<p class="mb-0 text-left">Hệ thống sẽ gọi API <strong>resolve-platform-order-ids</strong> với đúng bộ lọc hiện tại (như Xuất excel / đồng bộ danh sách).</p>' +
            '<p class="mb-0 mt-2 text-left small text-muted">Giới hạn tối đa <strong>10.000</strong> đơn. Nếu bị truncate, có cảnh báo.</p>' +
            '<p class="mb-0 mt-2 text-left small">Sau khi có danh sách mã đơn, dùng <strong>Đã chọn → Xác nhận đơn đã chọn</strong> để ship hàng loạt.</p>',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Chạy resolve',
          cancelButtonText: 'Hủy',
          width: 560,
        })
        if (!sw.isConfirmed) return

        this.resolvingShipmentSelectAll = true
        try {
          const payload = this.buildResolveShipmentSelectionPayload()
          const raw = await shopeeAdminRepo.resolvePlatformOrderIds(payload)
          if (raw && raw.success === false) {
            throw new Error(raw.error || raw.message || 'Resolve danh sách đơn thất bại')
          }
          let list =
            raw?.externalOrderIds ||
            raw?.external_order_ids ||
            []
          if (!Array.isArray(list)) {
            list = []
          }
          const normalized = [...new Set(list.map((x) => String(x || '').trim()).filter(Boolean))]
          this.selectedTrackingOrderSns = normalized

          if (!normalized.length) {
            toast.makeToastFailure('Không có mã đơn nào khớp filter.')
            return
          }

          let msg = `Đã đưa ${normalized.length} mã đơn vào lựa chọn.`
          if (raw?.totalMatched != null) {
            msg += ` (khớp: ${raw.totalMatched})`
          }
          if (raw?.truncated) {
            toast.makeToastFailure(
              `${msg} Kết quả bị giới hạn (truncated). Thu hẹp bộ lọc hoặc tăng cap phía máy chủ nếu hỗ trợ.`,
            )
          } else {
            toast.makeToastSuccess(msg)
          }
        } catch (e) {
          console.error(e)
          toast.makeToastFailure(
            this.extractAxiosErrorMessage(e, 'Không resolve được danh sách đơn theo filter'),
          )
        } finally {
          this.resolvingShipmentSelectAll = false
        }
      },
      async handleBulkCreateShipmentFlow() {
        await this.runBulkShipmentFlowForSelection('create')
      },
      async handleBulkConfirmShipOrderFlow() {
        await this.runBulkShipmentFlowForSelection('confirm')
      },
      async runBulkShipmentFlowForSelection(apiMode) {
        if (!this.selectedConnectionId) {
          toast.makeToastFailure('Vui lòng chọn gian hàng')
          return
        }
        const bulkApiMode = apiMode === 'confirm' ? 'confirm' : 'create'
        const eligible =
          bulkApiMode === 'confirm'
            ? this.eligibleConfirmShipOrdersForSelection
            : this.eligibleCreateShipmentOrdersForSelection
        if (!eligible.length) {
          toast.makeToastFailure(
            bulkApiMode === 'confirm'
              ? 'Không có đơn đã chọn đủ để confirm-ship-order (READY_TO_SHIP hoặc RETRY_SHIP + đã sync, hoặc mã sau resolve API).'
              : 'Không có đơn đã chọn đủ để create-shipment (READY_TO_SHIP, RETRY_SHIP hoặc PROCESSED + đã sync, hoặc mã sau resolve API).',
          )
          return
        }
        const idsOnGrid = new Set(this.logs.map((o) => o.externalOrderId))
        const extrasFromResolve = eligible.filter((o) => o.externalOrderId && !idsOnGrid.has(o.externalOrderId)).length
        let totalHint = ''
        if (extrasFromResolve > 0) {
          totalHint =
            `<p class="text-muted small mt-2 mb-0">Có ${extrasFromResolve} đơn nằm ngoài trang hiện tại ` +
            '(chọn bằng resolve theo filter).</p>'
        } else if (this.pagination.total > eligible.length && eligible.length <= this.logs.length) {
          totalHint = `<p class="text-muted small mt-2 mb-0">Danh sách chỉ có ${eligible.length}/${this.pagination.total} đơn khớp lọc (trang).</p>`
        }

        const apiLine =
          bulkApiMode === 'confirm'
            ? '<strong>confirm-ship-order</strong> — chỉ ship_order / PROCESSED (không bắt buộc có mã ngay).'
            : '<strong>create-shipment</strong> — đầy đủ (tracking, ưu tiên lấy mã vận đơn).'
        const dialogTitle =
          bulkApiMode === 'confirm' ? 'Xác nhận ship_order đã chọn' : 'Tạo shipment đã chọn'

        const confirm = await Swal.fire({
          title: dialogTitle,
          html:
            `<p class="mb-0">Sẽ xử lý <strong>${eligible.length}</strong> đơn đã chọn trên Shopee.</p>` +
            `<p class="small text-muted mt-2 mb-3 mb-md-4 text-left">API: ${apiLine}</p>` +
            `<div class="form-group mb-0 text-left">` +
            `<div class="custom-control custom-checkbox mt-0">` +
            `<input type="checkbox" class="custom-control-input" id="bulk-ship-confirm-before">` +
            `<label class="custom-control-label small" for="bulk-ship-confirm-before">` +
            `Gọi confirm trước khi ship (<code class="small">confirmOrderBeforeShip</code>) — UNPAID / giữ hành vi cũ` +
            `</label></div>` +
            `<div class="custom-control custom-checkbox mt-2">` +
            `<input type="checkbox" class="custom-control-input" id="bulk-ship-force-confirm">` +
            `<label class="custom-control-label small" for="bulk-ship-force-confirm">` +
            `Ép thử confirm (<code class="small">forceConfirmOrder</code>) — chỉ khi nhánh confirm được bật` +
            `</label></div>` +
            `<p class="small text-muted mt-2 mb-0">GET shipping-parameter (luồng từng đơn) vẫn dùng để chọn pickup/dropoff khi cần.</p>` +
            `</div>` +
            `<p class="mb-0 mt-2 small text-muted">Ưu tiên phương án ship đầu tiên từ Shopee; không có preset thì gửi kiểu tự động.</p>` +
            totalHint,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Hủy',
          width: 560,
          focusConfirm: false,
          preConfirm: () => ({
            apiMode: bulkApiMode,
            confirmOrderBeforeShip: !!document.getElementById('bulk-ship-confirm-before')?.checked,
            forceConfirmOrder: !!document.getElementById('bulk-ship-force-confirm')?.checked,
          }),
        })
        if (!confirm.isConfirmed) {
          return
        }

        const bulkConfirmOpts = {
          confirmOrderBeforeShip: !!confirm.value?.confirmOrderBeforeShip,
          forceConfirmOrder: !!confirm.value?.forceConfirmOrder,
        }
        await this.runBulkCreateShipment(eligible, bulkApiMode, bulkConfirmOpts)
      },
      async runBulkCreateShipment(orders, apiMode = 'create', confirmOpts = {}) {
        this.bulkCreatingShipment = true
        let ok = 0
        let fail = 0
        const useConfirm = apiMode === 'confirm'
        try {
          for (const order of orders) {
            const sn = order.externalOrderId
            try {
              this.clearRowActionError(sn)
              this.creatingShipmentIds.push(sn)
              let extras = {}
              try {
                const resolved = await this.resolveAutoShipmentExtras(order, confirmOpts)
                extras = resolved.extras || {}
              } catch (pe) {
                const pmsg = this.extractAxiosErrorMessage(
                  pe,
                  pe?.message || 'Không lấy được tham số ship',
                )
                throw new Error(pmsg)
              }
              const shipPkg = resolveShopeePackageNumberForShipApi(order)
              const body = {
                orderSn: sn,
                connectionId: order.marketplaceConnectionId,
                ...(shipPkg !== undefined ? { packageNumber: shipPkg } : {}),
                ...buildShopeeConfirmOrderPayload(confirmOpts),
                ...extras,
              }
              const res = useConfirm
                ? await shopeeAdminRepo.confirmShipOrder(body)
                : await shopeeAdminRepo.createShipment(body)
              this.throwIfCreateShipmentFailed(res)
              ok += 1
            } catch (error) {
              fail += 1
              const msg = this.extractAxiosErrorMessage(error, 'Không thể tạo vận đơn')
              this.setRowActionError(sn, msg)
            } finally {
              this.creatingShipmentIds = this.creatingShipmentIds.filter((id) => id !== sn)
            }
          }
        } finally {
          this.bulkCreatingShipment = false
        }

        if (fail === 0) {
          toast.makeToastSuccess(
            useConfirm
              ? `Đã xác nhận ship_order thành công ${ok} đơn`
              : `Đã xác nhận thành công ${ok} đơn`,
          )
        } else {
          toast.makeToastFailure(`Xong: ${ok} thành công, ${fail} lỗi (xem cột thao tác / toast).`)
        }
        await this.fetchLogs()
      },
      checkPermissions,
      canChangeInternalOrderStatusForLog(order) {
        return !!order?.orderId
      },
      logRowsForInternalStatusChange() {
        return this.logs.filter(
          (order) =>
            this.selectedTrackingOrderSns.includes(order.externalOrderId) &&
            this.canChangeInternalOrderStatusForLog(order),
        )
      },
      async handleChangeInternalOrderStatusBatch() {
        const rows = this.logRowsForInternalStatusChange()
        if (!rows.length) {
          toast.makeToastFailure('Chọn ít nhất một đơn có Order ID hệ thống để đổi trạng thái')
          return
        }
        const payload = rows.map((r) => ({ id: r.orderId }))
        await this.$store.dispatch(SET_ORDER_STATUS_SELECTED, payload)
        EventBus.$emit('popup-common-order')
      },
      async handleChangeInternalOrderStatusOne(order) {
        if (!this.canChangeInternalOrderStatusForLog(order)) {
          toast.makeToastFailure('Đơn chưa có Order ID hệ thống')
          return
        }
        await this.$store.dispatch(SET_ORDER_STATUS_SELECTED, [{ id: order.orderId }])
        EventBus.$emit('popup-common-order')
      },
      onInternalOrderStatusChanged(flag) {
        if (flag) {
          this.selectedTrackingOrderSns = []
          this.fetchLogs()
        }
      },
      syncSelectedTrackingOrderSnsWithCurrentLogs() {
        const available = new Set(
          this.logs
            .filter((order) => !!order.externalOrderId)
            .map((order) => order.externalOrderId),
        )
        this.selectedTrackingOrderSns = this.selectedTrackingOrderSns.filter((sn) =>
          available.has(sn),
        )
      },
      handleToggleSelectOrder({ orderSn, checked }) {
        if (!orderSn) return
        if (checked) {
          if (!this.selectedTrackingOrderSns.includes(orderSn)) {
            this.selectedTrackingOrderSns = [...this.selectedTrackingOrderSns, orderSn]
          }
          return
        }
        this.selectedTrackingOrderSns = this.selectedTrackingOrderSns.filter((sn) => sn !== orderSn)
      },
      handleToggleSelectAll({ orderSns, checked }) {
        const validOrderSns = Array.isArray(orderSns) ? orderSns.filter(Boolean) : []
        if (!validOrderSns.length) return
        if (checked) {
          this.selectedTrackingOrderSns = Array.from(
            new Set([...this.selectedTrackingOrderSns, ...validOrderSns]),
          )
          return
        }
        const removed = new Set(validOrderSns)
        this.selectedTrackingOrderSns = this.selectedTrackingOrderSns.filter(
          (sn) => !removed.has(sn),
        )
      },
      async handleRetry(order) {
        const result = await Swal.fire({
          title: 'Xác nhận',
          text: `Bạn có chắc muốn thử lại đồng bộ đơn hàng ${order.externalOrderId}?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Thử lại',
          cancelButtonText: 'Hủy',
        })

        if (result.isConfirmed) {
          try {
            this.retryingIds.push(order.id)
            await shopeeAdminRepo.retryOrder({
              externalOrderId: order.externalOrderId,
              connectionId: order.marketplaceConnectionId,
            })
            toast.makeToastSuccess('Đã gửi yêu cầu thử lại đồng bộ')
            await this.fetchLogs()
          } catch (error) {
            console.error('Error retrying order:', error)
            toast.makeToastFailure('Không thể thử lại đồng bộ đơn hàng')
          } finally {
            this.retryingIds = this.retryingIds.filter((id) => id !== order.id)
          }
        }
      },
      async handleSyncOneOrder(order) {
        const sn = order.externalOrderId
        try {
          this.clearRowActionError(sn)
          this.syncingOneOrderIds.push(sn)
          const response = await shopeeAdminRepo.syncOneOrder({
            orderSn: sn,
            connectionId: order.marketplaceConnectionId,
          })
          if (response?.success === false) {
            const msg = this.extractApiFailureMessage(response, 'Không thể đồng bộ đơn hàng')
            this.setRowActionError(sn, msg)
            toast.makeToastFailure(msg)
          } else {
            toast.makeToastSuccess('Đã đồng bộ đơn hàng thành công')
            await this.fetchLogs()
          }
        } catch (error) {
          console.error('Error syncing one order:', error)
          const msg = this.extractAxiosErrorMessage(error, 'Không thể đồng bộ đơn hàng')
          this.setRowActionError(sn, msg)
          toast.makeToastFailure(msg)
        } finally {
          this.syncingOneOrderIds = this.syncingOneOrderIds.filter((id) => id !== sn)
        }
      },
      async handleSyncByOrderSn() {
        if (!this.selectedConnectionId) {
          toast.makeToastFailure('Vui lòng chọn gian hàng trước khi sync')
          return
        }

        const result = await Swal.fire({
          title: 'Sync đơn hàng theo Order Sn',
          input: 'text',
          inputLabel: 'Order Sn',
          inputPlaceholder: '230101ABCD1234',
          showCancelButton: true,
          confirmButtonText: 'Sync',
          cancelButtonText: 'Hủy',
          inputValidator: (value) => {
            if (!value?.trim()) return 'Vui lòng nhập Order Sn'
          },
        })

        if (result.isConfirmed && result.value) {
          const orderSn = result.value.trim()
          try {
            this.clearRowActionError(orderSn)
            this.syncingByOrderSn = true
            const response = await shopeeAdminRepo.syncOneOrder({
              orderSn,
              connectionId: this.selectedConnectionId,
            })
            if (response?.success === false) {
              const msg = this.extractApiFailureMessage(response, 'Không thể đồng bộ đơn hàng')
              this.setRowActionError(orderSn, msg)
              toast.makeToastFailure(msg)
            } else {
              toast.makeToastSuccess('Đã đồng bộ đơn hàng thành công')
              await this.fetchLogs()
            }
          } catch (error) {
            console.error('Error syncing order by orderSn:', error)
            const msg = this.extractAxiosErrorMessage(error, 'Không thể đồng bộ đơn hàng')
            this.setRowActionError(orderSn, msg)
            toast.makeToastFailure(msg)
          } finally {
            this.syncingByOrderSn = false
          }
        }
      },
      async handlePrintTrackingByOrderSn() {
        if (!this.selectedConnectionId) {
          toast.makeToastFailure('Vui lòng chọn gian hàng trước khi in mã vận đơn')
          return
        }

        const result = await Swal.fire({
          title: 'In mã vận đơn theo Order Sn',
          input: 'text',
          inputLabel: 'Order Sn',
          inputPlaceholder: '230101ABCD1234',
          showCancelButton: true,
          confirmButtonText: 'In',
          cancelButtonText: 'Hủy',
          inputValidator: (value) => {
            if (!value?.trim()) return 'Vui lòng nhập Order Sn'
          },
        })

        if (result.isConfirmed && result.value) {
          const orderSn = result.value.trim()
          try {
            this.printingTrackingByOrderSn = true
            const mode = await this.openTrackingByApi(
              this.buildPrintTrackingParams(
                {},
                {
                  orderSn,
                  connectionId: this.selectedConnectionId,
                },
              ),
              true,
            )
            toast.makeToastSuccess(
              mode === 'pdf' ? 'Đã mở PDF vận đơn để in' : 'Đã mở dữ liệu vận đơn',
            )
          } catch (error) {
            console.error('Error printing tracking:', error)
            toast.makeToastFailure(
              error.response?.data?.message || error.message || 'Không thể in mã vận đơn',
            )
          } finally {
            this.printingTrackingByOrderSn = false
          }
        }
      },
      async handlePrintTrackingBatch() {
        const selectedOrders = this.logs.filter(
          (order) =>
            this.selectedTrackingOrderSns.includes(order.externalOrderId) &&
            this.canSelectForBatchPrint(order),
        )
        if (!selectedOrders.length) {
          toast.makeToastFailure('Vui lòng chọn đơn hợp lệ để in đồng loạt')
          return
        }
        try {
          this.printingTrackingBatch = true
          selectedOrders.forEach((order) => {
            if (order.externalOrderId) this.clearRowActionError(order.externalOrderId)
          })
          const orderList = selectedOrders.map((order) => {
            const item = {
              orderSn: order.externalOrderId,
              connectionId: order.marketplaceConnectionId,
            }
            if (order.orderId) item.orderId = order.orderId
            const pkg = resolveShopeePackageNumberForShipApi(order)
            if (pkg) item.packageNumber = pkg
            return item
          })
          const response = await shopeeAdminRepo.fetchPrintTrackingPdfBatch({
            connectionId: this.selectedConnectionId || undefined,
            orderSnList: orderList.map((item) => item.orderSn),
            orderList,
            stopOnError: false,
            ...buildShopeeConfirmOrderPayload({}),
          })
          const resultItems = Array.isArray(response?.data) ? response.data : []
          if (!resultItems.length && response?.success === false) {
            throw new Error(response?.message || response?.error || 'In đồng loạt thất bại')
          }
          const successItems = []
          const failedItems = []
          resultItems.forEach((item) => {
            if (item?.success && item?.data?.pdfBase64) {
              successItems.push(item)
              return
            }
            failedItems.push(item)
          })
          const returnedOrderSnSet = new Set(
            successItems.map((item) => String(item?.orderSn || '')).filter(Boolean),
          )
          const batchTouchedOrderSnSet = new Set(
            resultItems.map((item) => String(item?.orderSn || '')).filter(Boolean),
          )
          const missingOrders = orderList.filter(
            (item) =>
              !returnedOrderSnSet.has(String(item.orderSn || '')) &&
              !batchTouchedOrderSnSet.has(String(item.orderSn || '')),
          )
          if (missingOrders.length) {
            const fallbackResults = await Promise.all(
              missingOrders.map(async (item) => {
                try {
                  const single = await shopeeAdminRepo.fetchPrintTrackingPdf({
                    orderSn: item.orderSn,
                    connectionId: item.connectionId,
                    orderId: item.orderId,
                    packageNumber: item.packageNumber,
                    ...buildShopeeConfirmOrderPayload({}),
                  })
                  const payload = single?.data ?? single
                  if (payload?.pdfBase64) {
                    return {
                      success: true,
                      orderSn: item.orderSn,
                      orderId: item.orderId,
                      packageNumber: item.packageNumber,
                      data: payload,
                    }
                  }
                  return {
                    success: false,
                    orderSn: item.orderSn,
                    orderId: item.orderId,
                    error: this.extractApiFailureMessage(single, 'Không lấy được PDF vận đơn'),
                  }
                } catch (e) {
                  return {
                    success: false,
                    orderSn: item.orderSn,
                    orderId: item.orderId,
                    error: this.extractAxiosErrorMessage(e, 'Không thể in mã vận đơn'),
                  }
                }
              }),
            )
            fallbackResults.forEach((item) => {
              if (item?.success && item?.data?.pdfBase64) {
                successItems.push(item)
              } else {
                failedItems.push(item)
              }
            })
          }
          const uniqueSuccessItems = Array.from(
            new Map(
              successItems.map((item) => {
                const key = [
                  item?.orderSn || '',
                  item?.orderId || '',
                  item?.data?.trackingNumber || '',
                  item?.packageNumber || '',
                ].join('|')
                return [key, item]
              }),
            ).values(),
          )
          if (uniqueSuccessItems.length > 0) {
            await mergeAndOpenPdfBase64List(
              uniqueSuccessItems.map((item) => item?.data?.pdfBase64).filter(Boolean),
            )
          }
          if (uniqueSuccessItems.length > 0) {
            toast.makeToastSuccess(
              `Đã mở ${uniqueSuccessItems.length}/${selectedOrders.length} vận đơn`,
            )
          } else {
            toast.makeToastFailure('Không lấy được dữ liệu vận đơn để in')
          }
          if (failedItems.length > 0) {
            this.applyBatchPrintRowErrors(failedItems)
            const failedOrderKeys = [
              ...new Set(
                failedItems
                  .map((item) => item?.orderSn)
                  .filter(Boolean)
                  .map((k) => String(k)),
              ),
            ]
            const failedLabel = failedOrderKeys.slice(0, 3).join(', ')
            toast.makeToastFailure(
              `Có ${failedOrderKeys.length} đơn lỗi${failedLabel ? `: ${failedLabel}` : ''}`,
            )
          }
          this.selectedTrackingOrderSns = []
        } catch (error) {
          console.error('Error printing tracking batch:', error)
          toast.makeToastFailure(
            error.response?.data?.message ||
              error.response?.data?.error ||
              error.message ||
              'Không thể in đồng loạt vận đơn',
          )
        } finally {
          this.printingTrackingBatch = false
        }
      },
      handleViewOrderDetail(order) {
        this.orderIdFromModal = order.orderId
        this.titleOrderFromModal = 'Chỉnh sửa đơn hàng'
        this.$bvModal.show('md-edit-order')
      },
      refreshOrder() {
        this.fetchLogs()
        this.$bvModal.hide('md-edit-order')
      },
      handleViewReturnDetail({ returnSn, connectionId }) {
        this.$refs.returnDetailModalRef?.open({ returnSn, connectionId })
      },
      handleCreateComplaint(orderLog) {
        const order = {
          platformOrderId: orderLog.platformOrderId ?? orderLog.id,
          orderId: orderLog.orderId,
        }
        this.$refs.createComplaintModalRef?.open(order)
      },
      async fetchComplaintMap() {
        const orderIds = [
          ...new Set(this.logs.map((l) => l.externalOrderId || l.platformOrderId).filter(Boolean)),
        ]
        if (!orderIds.length) {
          this.complaintMap = {}
          return
        }
        try {
          const complaints = await shopeeAdminRepo.getComplaintsByOrderNumbers(orderIds)
          const map = {}
          complaints.forEach((c) => {
            const key = c.orderNumber || c.platformOrderId
            if (key) {
              map[key] = {
                id: c.id,
                isClosed: c.isClosed,
                processingStatus: c.processingStatus,
              }
            }
          })
          this.complaintMap = map
        } catch (e) {
          this.complaintMap = {}
        }
      },
      handleComplaintCreated() {
        this.fetchLogs()
      },
      async handlePrintTracking(order) {
        const sn = order.externalOrderId
        try {
          this.clearRowActionError(sn)
          this.printingTrackingIds.push(sn)
          const mode = await this.openTrackingByApi(this.buildPrintTrackingParams(order), true)
          toast.makeToastSuccess(
            mode === 'pdf' ? 'Đã mở PDF vận đơn để in' : 'Đã mở dữ liệu vận đơn',
          )
        } catch (error) {
          console.error('Error printing tracking:', error)
          const msg = this.extractAxiosErrorMessage(error, 'Không thể in mã vận đơn')
          this.setRowActionError(sn, msg)
          toast.makeToastFailure(msg)
        } finally {
          this.printingTrackingIds = this.printingTrackingIds.filter((id) => id !== sn)
        }
      },
      async handlePrintTrackingPdf(order) {
        const sn = order.externalOrderId
        try {
          this.clearRowActionError(sn)
          this.printingPdfIds.push(sn)
          const apiRes = await shopeeAdminRepo.fetchPrintTrackingPdf(
            this.buildPrintTrackingParams(order),
          )
          const mode = processPrintTrackingApiResponse(apiRes)
          toast.makeToastSuccess(
            mode === 'pdf' ? 'Đã mở PDF phiếu giao (Shopee)' : 'Đã mở dữ liệu phiếu giao',
          )
        } catch (error) {
          console.error('Error print PDF:', error)
          const msg = this.extractAxiosErrorMessage(error, 'Không thể tải PDF phiếu giao')
          this.setRowActionError(sn, msg)
          toast.makeToastFailure(msg)
        } finally {
          this.printingPdfIds = this.printingPdfIds.filter((id) => id !== sn)
        }
      },
      handleCreateShipment(order) {
        return this.openSingleShipmentDialog(order, 'create')
      },
      handleConfirmShipOrder(order) {
        return this.openSingleShipmentDialog(order, 'confirm')
      },
      async openSingleShipmentDialog(order, shipmentApiMode) {
        const snPlain = order.externalOrderId
        const snSafe = String(snPlain == null ? '' : snPlain)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')

        const dialogTitle =
          shipmentApiMode === 'confirm'
            ? 'Xác nhận ship_order (confirm-ship-order)'
            : 'Tạo shipment (create-shipment)'

        Swal.fire({
          title: 'Đang tải phương án vận chuyển…',
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        })

        let shipChoices = []
        let parameterErrorRaw = null
        const pkgIdentifier = resolveShopeePackageNumberForShipApi(order)
        try {
          const res = await shopeeAdminRepo.fetchShippingParameter({
            orderSn: snPlain,
            connectionId: order.marketplaceConnectionId,
            ...(pkgIdentifier ? { packageNumber: pkgIdentifier } : {}),
          })
          if (res?.success === false) {
            parameterErrorRaw =
              res?.error || res?.message || 'Không lấy được tham số ship từ Shopee'
          } else {
            shipChoices = derivePresetShipChoices(res?.data)
          }
        } catch (e) {
          console.error('shipping-parameter:', e)
          parameterErrorRaw = this.extractAxiosErrorMessage(
            e,
            'Không lấy được thông tin ship từ Shopee',
          )
        } finally {
          Swal.close()
        }
        shipChoices = finalizeShipChoices(order, shipChoices)

        const confirm = await Swal.fire({
          title: dialogTitle,
          width: 560,
          html: getShipmentConfirmSwalHtml({
            snSafe,
            choices: shipChoices,
            parameterError: parameterErrorRaw,
            spxPickupRequired: orderRequiresPickupNotDropoff(order),
            fixedShipmentApiMode: shipmentApiMode,
          }),
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Xác nhận',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          confirmButtonColor: '#3699ff',
          cancelButtonColor: '#E5EAEE',
          reverseButtons: true,
          focusConfirm: false,
          customClass: {
            popup: 'swal-popup-shipment-manual border-0',
          },
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
          didOpen: () =>
            attachShipmentConfirmDialogListeners({
              preferFirstPreset: shipChoices.length > 0,
            }),
          preConfirm: () => parseShipmentConfirmPreConfirm(shipChoices),
        })
        if (!confirm.isConfirmed) return

        const bundle = confirm.value
        if (!bundle || typeof bundle !== 'object') return
        const apiMode = bundle.apiMode === 'confirm' ? 'confirm' : 'create'
        const manualPayload = buildCreateShipmentExtras(bundle.choice)
        const implicitShipExtras =
          !manualPayload.shipType && getDropoffShipmentPayloadFromOrderPackageList(order)
        const sn = order.externalOrderId
        try {
          this.clearRowActionError(sn)
          this.creatingShipmentIds.push(sn)
          const shipPkg = resolveShopeePackageNumberForShipApi(order)
          const body = {
            orderSn: sn,
            connectionId: order.marketplaceConnectionId,
            ...(shipPkg !== undefined ? { packageNumber: shipPkg } : {}),
            ...buildShopeeConfirmOrderPayload({
              confirmOrderBeforeShip: bundle.confirmOrderBeforeShip,
              forceConfirmOrder: bundle.forceConfirmOrder,
            }),
            ...implicitShipExtras,
            ...manualPayload,
          }
          const res =
            apiMode === 'confirm'
              ? await shopeeAdminRepo.confirmShipOrder(body)
              : await shopeeAdminRepo.createShipment(body)
          const inner = this.throwIfCreateShipmentFailed(res)
          this.toastCreateShipmentOutcome(inner)
          await this.fetchLogs()
        } catch (error) {
          console.error('Error create shipment:', error)
          const msg = this.extractAxiosErrorMessage(
            error,
            apiMode === 'confirm'
              ? 'Không thể xác nhận ship_order trên Shopee'
              : 'Không thể tạo vận đơn',
          )
          this.setRowActionError(sn, msg)
          toast.makeToastFailure(msg)
        } finally {
          this.creatingShipmentIds = this.creatingShipmentIds.filter(
            (id) => id !== order.externalOrderId,
          )
        }
      },
      handleViewError(order) {
        const errorData = {
          code: 'SYNC_ERROR',
          message: order.errorMessage || 'Unknown error',
          timestamp: order.createdAt,
          stackTrace: null,
        }
        this.$refs.errorModal.show(errorData)
      },
      async handleSyncStatusToShopee(order) {
        const result = await Swal.fire({
          title: 'Xác nhận',
          text: `Đẩy trạng thái đơn hàng ${order.externalOrderId} (ID: ${order.orderId}) lên sàn Shopee?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy',
        })

        if (result.isConfirmed) {
          const sn = order.externalOrderId
          try {
            if (sn) this.clearRowActionError(sn)
            this.syncingStatusIds.push(order.orderId)
            await shopeeAdminRepo.syncStatusToShopee({
              orderId: order.orderId,
              useOrderSnAsFallback: true,
            })
            toast.makeToastSuccess('Đã đẩy trạng thái lên Shopee thành công')
            await this.fetchLogs()
          } catch (error) {
            console.error('Error syncing status to Shopee:', error)
            const msg = this.extractAxiosErrorMessage(error, 'Không thể đẩy trạng thái lên Shopee')
            if (sn) this.setRowActionError(sn, msg)
            toast.makeToastFailure(msg)
          } finally {
            this.syncingStatusIds = this.syncingStatusIds.filter((id) => id !== order.orderId)
          }
        }
      },
      async handleTriggerSync() {
        if (!this.selectedConnectionId) {
          toast.makeToastFailure('Vui lòng chọn gian hàng trước khi đồng bộ')
          return
        }

        const result = await Swal.fire({
          title: 'Xác nhận đồng bộ',
          text: 'Hệ thống sẽ lấy tất cả đơn hàng từ sàn TMĐT kể từ lần đồng bộ trước. Tiếp tục?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Đồng bộ ngay',
          cancelButtonText: 'Hủy',
        })

        if (result.isConfirmed) {
          try {
            this.syncing = true
            const response = await shopeeAdminRepo.triggerOrderSync({
              connectionId: this.selectedConnectionId,
            })
            const payload = response?.data != null ? response.data : response
            const totalOrders = payload?.totalOrders ?? 0

            if (totalOrders > 0) {
              toast.makeToastSuccess(`Đã đưa ${totalOrders} đơn hàng vào hàng đợi đồng bộ`)
            } else {
              toast.makeToastSuccess('Không có đơn hàng mới cần đồng bộ')
            }

            await this.fetchLogs()
            // Đồng bộ hàng loạt có thể hoàn tất sau vài giây — làm mới thêm một lần
            setTimeout(() => {
              this.fetchLogs()
            }, 3000)
          } catch (error) {
            console.error('Error triggering sync:', error)
            toast.makeToastFailure('Không thể kích hoạt đồng bộ đơn hàng')
          } finally {
            this.syncing = false
          }
        }
      },
      navigateBack() {
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.push({ name: 'platform-integration-list' })
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .order-logs-page {
  &__header {
    margin-bottom: 1rem;
  }

  &__external-status-tabs-wrap {
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
  }

  &__external-status-tabs-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px 16px;
    padding: 10px 12px 0;
    background: #fafafa;
  }

  &__external-status-tabs-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 4px;
    flex: 1 1 auto;
    min-width: 0;
    border-bottom: 1px solid #d9d9d9;
    margin-right: -2px;
  }

  &__external-status-tab {
    cursor: pointer;
    border: 1px solid transparent;
    border-bottom: none;
    background: transparent;
    margin: 0 0 -1px;
    padding: 10px 18px;
    font-family: inherit;
    font-size: 0.875rem;
    line-height: 1.4;
    border-radius: 6px 6px 0 0;
    color: #262626;
    outline: none;
    transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;

    &:focus-visible {
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.35);
      z-index: 2;
    }

    &:hover:not(&--active) {
      color: #1890ff;
    }
  }

  &__external-status-tab-label {
    font-weight: 700;
    color: inherit;
  }

  &__external-status-tab-count {
    font-weight: 600;
    font-size: 0.8125rem;
    color: #8c8c8c;
    margin-left: 2px;
  }

  &__external-status-tab--active {
    position: relative;
    z-index: 1;
    background: #fff;
    color: #1890ff;
    border-color: #d9d9d9;
    border-bottom: 1px solid #fff;

    .order-logs-page__external-status-tab-label {
      color: #1890ff;
    }

    .order-logs-page__external-status-tab-count {
      color: #8c8c8c;
    }
  }

  &__external-status-tabs-loading {
    font-size: 0.75rem;
    color: #8c8c8c;
    padding-bottom: 11px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  &__external-status-tabs-hint {
    display: block;
    padding: 8px 12px 10px;
    font-size: 0.75rem;
    color: #8c8c8c;
    border-top: 1px solid #f0f0f0;
    background: #fff;
  }

  &__empty {
    background: white;
    border-radius: 4px;
    padding: 2rem;

    .icon-3x {
      font-size: 3rem;
      display: block;
    }
  }
}
</style>

<style lang="scss">
  #md-edit-order {
  @media (min-width: 1200px) {
    .modal-dialog.modal-xl {
      max-width: 1200px;
    }
  }

  .modal-body {
    padding: 0;
  }
}
</style>

